/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../app.core.module.js';
import accountConfig from './account.config.js';
import accountRoute from './account.route.js';
import accountController from './account.controller.js';
import accountService from './account.service.js';
import accountDataService from './account.data.service.js';

/**
 * This is the account module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace Account Module
 */
angular.module('account', [
  // Shared modules.
  core
])
// Register config.
.config(accountConfig)
// Register route.
.config(accountRoute)
// Register controller.
.controller('accountController', accountController)
// Register service.
.factory('accountService', accountService)
// Register data service.
.factory('accountDataService', accountDataService)
.directive("antiForgeryToken", function () {
	return {
		restrict: 'E',
		replace: true,
		scope: {
			token: "="
		},
		template: "<input type='hidden' name='{{token.name}}' value='{{token.value}}'>"
	};
});

export default 'account';


// WEBPACK FOOTER //
// ./src/login/account/account.module.js